/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//The code below hides the images that are not from the selected variant (image group), and shows the ones that are part of it
//Written to work with the custom image gallery only
(function(){
  if( !document.querySelector('.HorizontalList__Item') ) return;
  var variantRadios = document.querySelectorAll(
    '.ColorSwatch__Radio, .SizeSwatch__Radio'
  );

  //convert all templates to div so we can select elements again
  function templateToDiv(){
    var templates = document.querySelectorAll('.Product_Gallery--6S template.Product_Gallery__Item')
    templates.forEach(function(template) {
      templateDivMagic(template)
    })
  }
  
  function templateDivMagic(targetElement){
    var newElement = document.createElement('template');
    
    if(targetElement.tagName.toLowerCase() == "template"){
      newElement = document.createElement('div');
    }            

    // Copy the element's attributes to the new element
    for (let i = 0; i < targetElement.attributes.length; i++) {
      const {name, value} = targetElement.attributes[i];
      newElement.setAttribute(name, value);
    }
    
    // Set the content of the new element to the content of the div element
    newElement.innerHTML = targetElement.innerHTML;
    
    // Replace the div element with the new element
    targetElement.parentNode.replaceChild(newElement, targetElement);
  }   

  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      templateToDiv();

      var variantImages = document.querySelectorAll('.Product_Gallery--6S img');            
      var selectedVariantGroup;

      if (this.classList.contains('ColorSwatch__Radio')) {
        selectedVariantGroup = this.dataset.group;
      } else {
        selectedVariantGroup =
          '#' +
          this.value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '');
      }
  
      variantImages.forEach(function(image) {
        //we can't just hide the images that do not belong to the group because they are stil accounted in the CSS grid-template, and we can't make it work with nth-of-type if we just hide them
        //instead of removing elements and putting them back, we simply transform them into a template tag that gets ignored if they are not part of the group, then make them a div if they are part, to be displayed
        if(image.dataset.group){
          if (image.dataset.group === selectedVariantGroup) {
            image.closest('.Product_Gallery__Item').parentElement.tagName == "template" && templateDivMagic(image.closest('.Product_Gallery__Item'))
          } else {
            templateDivMagic(image.closest('.Product_Gallery__Item'))            
          }
        }
      });
    });
  });

  /* This piece of cod crosses out size/letter variants when another variant is selected, such as colour */
  const variantNonSizeInputs = document.querySelectorAll('.ProductForm__Variants input:not([class*="SizeSwatch"])')
  const variantSizeInputs = document.querySelectorAll('.ProductForm__Variants input[class*="SizeSwatch"]')
  const jsonData = document.querySelector('[data-product-json]')?JSON.parse(document.querySelector('[data-product-json]').innerHTML):"";
  const productData = jsonData['product'];

  if(!jsonData) return;
  if(!variantNonSizeInputs || variantNonSizeInputs.length < 1 ) return;
  
  function _updateSizeVariants(){
    if(!variantSizeInputs || !variantNonSizeInputs) return

    variantNonSizeInputs.forEach( variantNonSizeInput => {
      variantNonSizeInput.addEventListener('change', () => {
        const nonSizeValue = variantNonSizeInput.value
        variantSizeInputs.forEach( variantSizeInput => {
          const variantSizeLabel = variantSizeInput.parentElement.querySelector('label')
          variantSizeLabel.classList.remove('SizeSwatch--OOS')
          const sizeValue = variantSizeInput.value
          productData['variants'].forEach(function (variant) {
            //console.log(nonSizeValue, sizeValue, variant.options, variant.available)
            if(variant.options.includes(sizeValue) && variant.options.includes(nonSizeValue)){
              if (!variant.available) variantSizeLabel.classList.add('SizeSwatch--OOS')
            }
          })
        })        
      })
    })
  }
  _updateSizeVariants()
  //Make sure to dispatch the event because it seems like it doesn't
  variantNonSizeInputs[0].dispatchEvent(new Event('change'))

})()


function addBundleMessage(){
  const slidecart = document.getElementById('slidecarthq')
  if(!slidecart) return;

  const cartItems = slidecart.querySelector('.items')
  cartItems.querySelectorAll('.item').forEach( cartItem => {
    const cartItemTitle = cartItem.querySelector('h3.title')
    const cartProperties = cartItem.querySelector('.properties-key-value')
    //product URL
    const productURL = cartItemTitle.querySelector('a')?.href.replace('?','.json?');

    fetch(productURL)
    .then( r => r.json() )
    .then( resp => {
      if(!resp.product) return;
  
      const productTags = resp.product.tags.split(",")
      const containsBundleTag = productTags.some(tag => tag.toLowerCase().includes("bundle"));

      if(!cartItemTitle.classList.contains("has-bundle-message") && containsBundleTag){
        cartItemTitle.classList.add('has-bundle-message')
        cartProperties.insertAdjacentHTML('afterend', '<span class="bundle-message">ORDER 3+ ITEMS & SAVE 20%</span>')
      }
    })
  })
} 

(function(){
  
  function addComparePricesToSC({ items }) {
    if(!items) return; 

    //console.log('addComparePricesToSC()') 
    items.forEach(async (item) => {
      try {
        let currentItemId = item.variant_id;  
        let response = await fetch(`/products/${item.handle}.js`); 
        let allInformation = await response.json();
  
        let { variants } = allInformation;  
        //console.log('variants', variants)
  
        variants.forEach( (variant) => {
          if(variant.id == currentItemId){
            const price = variant.price
            const compare_at_price = variant.compare_at_price
            //console.log('price',price,'compare_at_price',compare_at_price)
            
            if (price > 0 && compare_at_price > 0 && price < compare_at_price) {
              let priceBlock = `<span class='price-compare-at'>${theme.moneyFormat.replace("{{amount_with_comma_separator}}",(compare_at_price / 100)).replace("{{amount}}",(compare_at_price / 100))}</span>
                                <span class='price'><span class='money'>${theme.moneyFormat.replace("{{amount_with_comma_separator}}",(price/100)).replace("{{amount}}",(price/100))}</span></span>`;
              let element = document.querySelector(`.slidecarthq .item[data-variant-id='${currentItemId}']`)
              if(!element) return
              let priceDiscountBlock = element.querySelector('.price-discount-block');
              if(priceDiscountBlock) priceDiscountBlock.innerHTML = priceBlock;
            }
          }
        })
      } catch (e) {
        console.log(e);
      }
    });
  }  
  
  let slidecartCurrency = Shopify.currency?.active?.toLowerCase();
  let slidecartCountry = Shopify.country?.toLowerCase();
  const freeShipExclusions = []; //['au', 'ca', 'nz', 'us', 'sg', 'ae'];
  
  function slidecartSetReward() {
    try {
      if (slidecartCountry == "gb") {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "200";
      } else if (freeShipExclusions.includes(slidecartCountry)) {
        window.SLIDECART_STATE().settings.rewards = false;
      } else {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "200";
      }
    } catch (err) {
      console.log(err);
    }
  }

  function slidecartSetRewardCurrency() {
    try {
      const state = window.SLIDECART_STATE?.();

      if (!state || !state.settings || !state.settings.rewards_tiers || !state.settings.rewards_tiers.length) {
        return; // Slidecart not ready yet
      }

      if (slidecartCurrency == "gbp") {
        state.settings.rewards_tiers[0].amount = "200";
      } else if (slidecartCurrency == "eur") {
        state.settings.rewards_tiers[0].amount = "200";
      } else if (slidecartCurrency == "usd") {
        state.settings.rewards_tiers[0].amount = "200";
      } else if (freeShipExclusions.includes(slidecartCountry)) {
        state.settings.rewards = false;
      } else {
        state.settings.rewards_tiers[0].amount = "200";
      }

    } catch (err) {
      console.log(err);
    }
  }

  const DEBUG = false;

  function log(...args) { if (DEBUG) console.log(...args); }
  function warn(...args) { if (DEBUG) console.warn(...args); }
  function group(...args) { if (DEBUG) console.group(...args); }
  function groupEnd() { if (DEBUG) console.groupEnd(); }

  function enhanceSlidecartUpsells() {
    group("[SlideCart] enhanceSlidecartUpsells");

    const slidecart = document.getElementById("slidecarthq");
    log("slidecart", slidecart);

    if (!slidecart) {
      warn("❌ No #slidecarthq");
      groupEnd();
      return;
    }

    const upsellsContainer = slidecart.querySelector(".upsells");
    log("upsellsContainer", upsellsContainer);

    if (!upsellsContainer) {
      warn("❌ No .upsells");
      groupEnd();
      return;
    }

    const upsellsStacked = upsellsContainer.querySelector(".upsells-stacked");
    log("upsellsStacked", upsellsStacked);

    if (!upsellsStacked) {
      warn("❌ No .upsells-stacked");
      groupEnd();
      return;
    }

    upsellsStacked.classList.remove("is-ready");

    const upsellItems = upsellsStacked.querySelectorAll(".upsell-item");
    log("Found upsell items:", upsellItems.length);
    
    // SALE LABELS    
    upsellItems.forEach((upsellItem, index) => {
      group(`Upsell ${index}`);

      const comparePrice = upsellItem
        .querySelector(".upsell-compare-at .money")
        ?.textContent.replace("£", "");

      let finalPrice = upsellItem
        .querySelector(".upsell-latest-price .money")
        ?.textContent.replace("£", "");

      if (!finalPrice) {
        finalPrice = upsellItem
          .querySelector("p:not(.upsell-latest-price):not(.upsell-compare-at) .money")
          ?.textContent.replace("£", "");
      }

      log("comparePrice", comparePrice);
      log("finalPrice", finalPrice);
      const itemImage = upsellItem.querySelector(".upsell-image");
      log("itemImage", itemImage);

      if (
        parseFloat(comparePrice) > 0 &&
        parseFloat(finalPrice) > 0 &&
        parseFloat(comparePrice) > parseFloat(finalPrice)
      ) {
        log("Item is on sale");

        if (!itemImage.querySelector(".ProductItem__Label")) {
          log("Adding badge");

          const badge = document.createElement("span");
          badge.className =
            "ProductItem__Label ProductItem__Label--onSale Heading Text--subdued";

          badge.textContent =
            Math.round(
              (parseFloat(comparePrice) - parseFloat(finalPrice)) *
              100 /
              parseFloat(comparePrice)
            ) + "% OFF";

          itemImage.appendChild(badge);

        } else {
          log("Badge already exists");
        }
      } else {
        log("Not discounted");
      }

      groupEnd();

    });

    log("Calling attachListenersToUpsellAddToCartButtons()");
    attachListenersToUpsellAddToCartButtons();

    //
    // STYLE
    //
    if (!document.getElementById("slidecart-upsell-style")) {

      log("Injecting style");

      const style = document.createElement("style");

      style.id = "slidecart-upsell-style";

      style.textContent = `
        #slidecarthq .upsells-stacked:before { display:none!important; }
        #slidecarthq .upsells-stacked:after { display:none!important; }
      `;

      document.head.appendChild(style);

    } else {

      log("Style already exists");

    }

    //
    // BUTTONS
    //
    log("Buttons already exist:", !!upsellsContainer.querySelector(".flickity-prev-next-button"));

    if (
      upsellItems.length > 2 &&
      !upsellsContainer.querySelector(".flickity-prev-next-button")
    ) {

      log("Creating navigation buttons");

      const prevButton = document.createElement("button");
      prevButton.className = "flickity-prev-next-button previous";
      prevButton.type = "button";
      prevButton.innerHTML = `
        <svg viewBox="0 0 100 100">
          <path class="arrow"
            d="M20,50 L60,90 L60,85 L25,50 L60,15 L60,10 Z"/>
        </svg>
      `;

      const nextButton = document.createElement("button");
      nextButton.className = "flickity-prev-next-button next";
      nextButton.type = "button";
      nextButton.innerHTML = `
        <svg viewBox="0 0 100 100">
          <path class="arrow"
            d="M20,50 L60,90 L60,85 L25,50 L60,15 L60,10 Z"/>
        </svg>
      `;

      upsellsContainer.append(prevButton, nextButton);

      log("Buttons appended");
    }

    //
    // LISTENERS
    //
    log("Already enhanced:", upsellsStacked.dataset.enhanced);

    function updateArrows() {
      upsellsStacked.classList.toggle(
        "slider-arrow-hidden-left",
        upsellsStacked.scrollLeft === 0
      );

      upsellsStacked.classList.toggle(
        "slider-arrow-hidden-right",
        upsellsStacked.scrollLeft + upsellsStacked.clientWidth >=
        upsellsStacked.scrollWidth
      );

    }

    function handleClick(event) {
      const rect = upsellsStacked.getBoundingClientRect();

      if (event.clientX < rect.left + 30) {
        upsellsStacked.scrollBy({
          left: -upsellsStacked.clientWidth,
          behavior: "smooth"
        });
      } else {
        upsellsStacked.scrollBy({
          left: upsellsStacked.clientWidth,
          behavior: "smooth"
        });

      }

    }

    const prevButton = upsellsContainer.querySelector(".previous");
    const nextButton = upsellsContainer.querySelector(".next");

    if (!upsellsStacked.dataset.scrollListener) {
      log("Attaching scroll listener");
      upsellsStacked.addEventListener("scroll", updateArrows);
      upsellsStacked.dataset.scrollListener = "1";
    }

    if (prevButton && !prevButton.dataset.listenerAttached) {
      log("Attaching previous button listener");
      prevButton.addEventListener("click", handleClick);
      prevButton.dataset.listenerAttached = "1";
    }

    if (nextButton && !nextButton.dataset.listenerAttached) {
      log("Attaching next button listener");
      nextButton.addEventListener("click", handleClick);
      nextButton.dataset.listenerAttached = "1";
    }

    updateArrows();

    //
    // HEIGHTS
    //
    const titles = upsellsStacked.querySelectorAll(".upsell-text > p");

    log("Titles:", titles.length);

    let maxHeight = 0;

    titles.forEach(el => {
      el.style.height = "auto";
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    log("Max height:", maxHeight);

    titles.forEach(el => {
      el.style.height = maxHeight + "px";
    });

    upsellsStacked.classList.add("is-ready");

    log("Finished enhanceSlidecartUpsells");

    groupEnd();

  }

  
  let slidecartEnhanceTimer = null;
  let slidecartObserver = null;

  function addDiscountLabelObserver() {

    const slidecart = document.getElementById("slidecarthq");

    if (!slidecart) {
      log("[SlideCart] slidecart not found");
      return;
    }

    // Already observing
    if (slidecartObserver) {
      return;
    }

    slidecartObserver = new MutationObserver((mutationsList) => {

      let shouldEnhance = false;

      for (const mutation of mutationsList) {

        if (mutation.type !== "childList") continue;

        for (const node of mutation.addedNodes) {

          if (node.nodeType !== Node.ELEMENT_NODE) continue;

          if (
            node.classList.contains("upsell") ||
            node.classList.contains("upsells") ||
            node.classList.contains("upsells-stacked") ||
            node.querySelector?.(".upsell") ||
            node.querySelector?.(".upsells") ||
            node.querySelector?.(".upsells-stacked")
          ) {
            shouldEnhance = true;
            break;
          }

        }

        if (shouldEnhance) break;

      }

      if (!shouldEnhance) return;

      clearTimeout(slidecartEnhanceTimer);

      slidecartEnhanceTimer = setTimeout(() => {

        log("[SlideCart] Enhancing upsells...");

        try {

          enhanceSlidecartUpsells();

        } catch (e) {

          if (DEBUG) console.error("[SlideCart]", e);

        }

      }, 150);

    });

    slidecartObserver.observe(slidecart, {
      childList: true,
      subtree: true
    });

    log("[SlideCart] Observer attached");

  }

  function addDiscountLabel(){
    const slidecart = document.getElementById('slidecarthq')
    //console.log('slidecart',slidecart)
    if(!slidecart) return;
      
    const upsellItems = slidecart.querySelector('.upsells-stacked');
    if (!upsellItems) return;
  
    upsellItems.querySelectorAll('.upsell-item').forEach( upsellItem => {
      //console.log('upsellItems',upsellItems)
      const comparePrice = upsellItem.querySelector('.upsell-compare-at .money')?.innerHTML.replace("£","")
      let finalPrice = upsellItem.querySelector('.upsell-latest-price .money')?.innerHTML.replace("£","")
      if(!finalPrice) finalPrice = upsellItem.querySelector('p:not(.upsell-latest-price):not(.upsell-compare-at) .money')?.innerHTML.replace("£","")
      const itemImage = upsellItem.querySelector('.upsell-image')
      //console.log('comparePrice',comparePrice, 'finalPrice', finalPrice, 'itemImage', itemImage)
  
      if(parseFloat(comparePrice) > 0 && parseFloat(finalPrice) > 0 && parseFloat(comparePrice) > parseFloat(finalPrice)){
        let discountPercentage = Math.round((parseFloat(comparePrice) - parseFloat(finalPrice)) * 100 / parseFloat(comparePrice));
        let discountLabel = '<span class="ProductItem__Label ProductItem__Label--onSale Heading Text--subdued">'+discountPercentage+'% OFF</span>'
        if(itemImage && !itemImage.classList.contains('upsell-labeled')) {
          itemImage.innerHTML = itemImage.innerHTML + discountLabel
          itemImage.classList.add('upsell-labeled')
        }
      }
    })
  }

  function correctAmpFooterCode(){
    const slidecart = document.getElementById('slidecarthq')
    if(!slidecart) return;
    const footerCode = slidecart.querySelector('.footer-code')
    if(!footerCode) return;
    
    let footerCodeText = footerCode.innerHTML
    if(!footerCodeText) return
    footerCodeText = footerCodeText.replace(/&amp;/g, '&');
    footerCode.innerHTML = footerCodeText
  }

   // Attach Klaviyo custom ATC tracking to Upsell ATC buttons 
    function attachListenersToUpsellAddToCartButtons() {
      var _learnq = window._learnq || [];
      const slidecart = document.getElementById('slidecarthq')
      var upsells = slidecart.querySelectorAll('.upsells-stacked .upsell')
      if(!upsells) return;

      const upsellsOptionsOverlays = slidecart.querySelectorAll('.upsell-options-overlay')
      
      upsells.forEach( upsell => {
        const productId = upsell.dataset.slidecartProductId
        const productImage = upsell.querySelector('.upsell-image a img')?.src
        const productTitle = upsell.querySelector('.upsell-text h3 a')?.innerHTML
        const productURL = upsell.querySelector('.upsell-text h3 a')?.href
        const productPrice = upsell.querySelector('.upsell-text-prices p .money')?.innerHTML
        const upsellOptionOverlay = slidecart.querySelector('.upsell-options-overlay[data-slidecart-product-id="'+productId+'"]')
        var atcButton = upsell.querySelector('.upsell-add button')
        if(upsellOptionOverlay){
          atcButton = upsellOptionOverlay.nextElementSibling?.querySelector('button.button')
        }
        if(atcButton){
          var klAjax = true;
          atcButton.addEventListener("click", function() {
            if (klAjax && !atcButton.dataset.listening) {
              let  item = {
                  Name: productTitle,
                  ProductID: productId,
                  //Categories: ["2024 SPRING COLOURS", "ALL PRODUCTS", "BEST OF SUMMER SALE", "Bridesmaid Dresses", "BRIDESMAID DRESSES UNDER £100", "CHIFFON BRIDESMAID DRESSES", "NEUTRAL BRIDESMAID DRESSES", "PRE ORDER - CHIFFON (Do Not Delete)", "SMARTSIZE - BRIDESMAID DRESSES - CHIFFON BOW TIE SHOULDER", "SUMMER SALE", "SUMMER SALE BRIDESMAID DRESSES"],
                  ImageURL: productImage,
                  URL: productURL,
                  Brand: "Six Stories",
                  Price: productPrice,
                  CompareAtPrice: ""
              };

              //console.log("ITEM TRACKED: ", item)
            
              _learnq.push(['track', 'Added to Cart', item]);
              atcButton.setAttribute('data-listening','true')
              klAjax = false;
            }
          });
        }
      })

    }

function loadNavidiumWidget() {

		const nvdShop = 'six-stories.myshopify.com';
		const nvdShopCurrency = '£{{amount}} GBP';
		const nvdControls = {
			subtotal_item: 'footer.footer.sticky-footer .footer-row strong.slidecart-subtotal span.money,.Cart__Recap p.Cart__Total.Heading.u-h6 span.money',
			CheckoutBtns: '[name="checkout"],[name="checkout"] *',
			clickTriggers: '.ProductForm__AddToCart,.ProductForm__AddToCart *,[href="/cart"],[href="/cart"] *,.quantity-selector button,.quantity-selector button *,.remove,.remove *,.upsell-add,.upsell-add *',
			changeTrigger: 'onchange_input_class_here',
			cursorControl: '.nvd-mini',
			showConsoleMessage: false,
			iosDeviceListener:'click',
			trackWidget: false,
			forceClick: true,
			forceCheckout: true,
			redirectCheckout: {
				upsaleOff: true,
				noProtection: false
    },
		nvdInject:{
			status:false, // Inject nvd-mini div
			parent:'#slidecart-checkout-form', // parent class for nvd-mini div
			container:'[name="checkout"]' // nvd-mini will added before this div/button
			}
		}		
    
    if (typeof nvd_init === 'function') {
      nvd_init();
      console.log('Navidium widget initialised.');
      packageProtectionModal()
    } else {
      console.warn('Navidium script not loaded yet.');
    }
    
  }


  function packageProtectionModal() {

    const modal = document.getElementById('packageProtectionModal');
    if (!modal) return;

    const closeButton = modal.querySelector('.six-stories-modal-close');

    function openModal() {
      modal.showModal();
      document.body.classList.add('six-stories-modal-open');
    }

    function closeModal() {
      modal.close();
      document.body.classList.remove('six-stories-modal-open');
    }

    modal.addEventListener('click', function (event) {
      const rect = modal.getBoundingClientRect();

      const isInDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!isInDialog) {
        closeModal();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    const nvdMini = document.querySelector('.nvd-mini');
    if (!nvdMini) return;

    const bindIfExists = () => {
      const infoTrigger = nvdMini.querySelector(
        '.appearance-right-previw-ld .d-flexCstm-ld h4'
      );

      if (infoTrigger && !infoTrigger.dataset.modalBound) {
        infoTrigger.addEventListener('click', openModal);
        infoTrigger.dataset.modalBound = "true"; // prevent duplicate binding
        console.log('Navidium trigger bound.');
      }
    };

    // Try immediately (in case already rendered)
    bindIfExists();

    // Observe future injections inside .nvd-mini
    const observer = new MutationObserver(() => {
      bindIfExists();
    });

    observer.observe(nvdMini, {
      childList: true,
      subtree: true
    });
  }
    
  window.SLIDECART_LOADED = (cart) => {
    console.log('CART LOADED')
    //if (slidecartCountry) slidecartSetReward();
    /*fetch('https://get.geojs.io/v1/ip/geo.json')
      .then((res)=>res.json())
      .then(res =>{
        SLIDECART_STATE().settings.announcements = false; 
        const location = res.country_code;
        console.log("Location: ", location);
        if (location == "US") {
          //SLIDECART_STATE().settings.announcements = true; 
        }
      });
    if (slidecartCurrency) slidecartSetRewardCurrency();
    */
    addDiscountLabelObserver();
    correctAmpFooterCode();
    loadNavidiumWidget();
  }
  
  window.SLIDECART_UPDATED = (cart) => {
    console.trace('Who called SLIDECART_UPDATED');

    console.log('CART UPDATED')
    //if (slidecartCountry) slidecartSetReward();
    if (slidecartCurrency) slidecartSetRewardCurrency();
    //addComparePricesToSC(cart)
    addDiscountLabelObserver()
    correctAmpFooterCode()
    
  }
  window.SLIDECART_OPENED = (cart) => {
    console.log('CART OPENED')
    //addComparePricesToSC(cart)
    addDiscountLabelObserver()
    correctAmpFooterCode()
    loadNavidiumWidget();
  }
})();

/*
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    //console.log(CozyCountryRedirect, CozyCountryRedirect.country, "XXXX")
    if(CozyCountryRedirect && CozyCountryRedirect.country && CozyCountryRedirect.country.toLowerCase() == "xxx"){
      console.log(CozyCountryRedirect, CozyCountryRedirect.country, "XXXX")
      let bundleFreeShippingMessage = document.querySelector('.rbr-totalBox__freeShipping_con')
      if(bundleFreeShippingMessage) bundleFreeShippingMessage.style.display = 'block'
    }
  }, 5000)
})
*/

/* Resize variant size boxes to match the widest one */
(function(){
  const list = document.querySelector(".SizeSwatchList");
  const lis = list?.querySelectorAll(".SizeSwatchList li");

  if (!list || !lis) return;

  let maxWidth = 0;
  lis.forEach(li => {
    const span = li.querySelector("label");
    const spanWidth = span.offsetWidth;
    if (spanWidth > maxWidth) {
      maxWidth = spanWidth;
    }
  });

  lis.forEach(li => {
    const span = li.querySelector("label");
    span.style.width = `${maxWidth}px`;
    span.style.height = `${maxWidth}px`;
  });
})()

function triggerNotAvailablePopup(){
  const notAvailableLink = document.getElementById('link--variant-not-available')
  //console.log('notAvailableLink', notAvailableLink)
  if(notAvailableLink){
    notAvailableLink.addEventListener('click', (e) => {
      e.preventDefault()
      const klaviyoNotifyMeButton = document.querySelector('.klaviyo-bis-trigger')
      if(klaviyoNotifyMeButton) klaviyoNotifyMeButton.click()
      return false;
    })
    notAvailableLink.style.display = 'inline-block'
  }
}

document.addEventListener("DOMContentLoaded", function() {
  triggerNotAvailablePopup()

  // Select all outer Flickity slider elements
  const outerSliders = document.querySelectorAll('.ProductList.ProductList--carousel');
  
  if (outerSliders.length > 0) {
      // Iterate over each outer slider
      outerSliders.forEach(outerSliderElement => {
          var outerFlickity = Flickity.data(outerSliderElement);
  
          // Make sure outer Flickity instance exists
          if (outerFlickity) {
              // Select all inner carousels within this outer slider
              const carousels = outerSliderElement.querySelectorAll('.ProductItem__ImageCarousel');
  
              // If inner carousels exist, apply the logic
              if (carousels.length > 0) {
                  carousels.forEach(carousel => {
                      // Disable dragging on the outer slider when interacting with the inner carousel
                      carousel.addEventListener('pointerdown', function(event) {
                          outerFlickity.unbindDrag(); // Disable dragging for the outer Flickity slider
                      });
  
                      // Re-enable dragging on the outer slider when interaction ends
                      carousel.addEventListener('pointerup', function(event) {
                          outerFlickity.bindDrag(); // Re-enable dragging for the outer Flickity slider
                      });
  
                      // Also re-enable dragging when the pointer leaves the inner slider
                      carousel.addEventListener('pointerleave', function(event) {
                          outerFlickity.bindDrag();
                      });
                  });
              }
          }
      });
  }
});

function normalizeNumber(num, threshold = 2) {
  return Math.round(num / threshold) * threshold;
}


// Function to equalize heights of product titles per row
function equalizeProductTitleHeights() {
  const gridCells = document.querySelectorAll('.Grid__Cell:not(.Grid__Cell--Equalised)');
  let currentRowTop = null;
  let titleElements = [];
  let fullTileAspectElements = [];
  let tallestTitleHeight = 0;
  let tallestCellHeight = 0;

  function normalizeNumber(num, roundTo) {
    return Math.round(num / roundTo) * roundTo;
  }

  function applyHeights() {
    // 1. Equalize titles
    titleElements.forEach(el => el.style.height = `${tallestTitleHeight}px`);

    // 2. Set .AspectRatio height in .FullTile
    fullTileAspectElements.forEach(aspect => {
      aspect.style.height = `${tallestCellHeight}px`;
      aspect.style.paddingBottom = '0';
    });
  }

  gridCells.forEach((cell) => {
    const cellTop = normalizeNumber(cell.getBoundingClientRect().top, 10);
    const isNewRow = currentRowTop !== null && cellTop !== currentRowTop;

    if (isNewRow) {
      applyHeights(); // Apply for previous row
      // Reset row state
      titleElements = [];
      fullTileAspectElements = [];
      tallestTitleHeight = 0;
      tallestCellHeight = 0;
    }

    currentRowTop = cellTop;

    // Track tallest full grid item
    tallestCellHeight = Math.max(tallestCellHeight, cell.offsetHeight);

    // Track tallest title
    const title = cell.querySelector('.ProductItem__Title');
    if (title) {
      titleElements.push(title);
      tallestTitleHeight = Math.max(tallestTitleHeight, title.offsetHeight);
    }

    // Track .AspectRatio if this is a full tile
    if (cell.classList.contains('Grid__Cell--FullTile')) {
      const aspect = cell.querySelector('.ProductItem__ImageWrapper .AspectRatio');
      if (aspect) fullTileAspectElements.push(aspect);
    }

    cell.classList.add('Grid__Cell--Equalised');
  });

  // Final row
  applyHeights();
}

// Run on DOM ready and resize
document.addEventListener('DOMContentLoaded', () => {
  equalizeProductTitleHeights();

  window.addEventListener('resize', () => {
    document.querySelectorAll('.Grid__Cell--Equalised').forEach(cell =>
      cell.classList.remove('Grid__Cell--Equalised')
    );
    equalizeProductTitleHeights();
  });
});





/*This was initially developed to emualte the hover over to show the arrows, but I was asked to remove it*/
if(false){
  window.addEventListener('load', () => {
    // Function to add the hover-like effect when the element is fully visible
    function addHoverEffectOnce(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add the hover-like class
          entry.target.classList.add('hover-simulated');
          
          // Remove the class after 2 seconds
          setTimeout(() => {
            entry.target.classList.remove('hover-simulated');
          }, 1000); 
    
          // Stop observing to avoid repeated triggers
          observer.unobserve(entry.target);
        }
      });
    }
    
    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver(addHoverEffectOnce, {
      threshold: 1.0 // Trigger when the element is fully visible
    });
    
    // Select the elements to observe
    const elements = document.querySelectorAll('.ProductItem__ImageCarousel');
    elements.forEach(element => observer.observe(element));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  let hasAnimated = false; // Flag to track if the animation has already occurred

  // Function to trigger slide action when the element is fully visible
  function triggerSliderOnce(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasAnimated) {
        // Perform the slide back-and-forth action
        var sliderElem = entry.target;
        var flkty = Flickity.data(sliderElem);

        if (flkty) {
          function slideBackAndForth() {
            // Slide to the second slide
            flkty.select(1);
            // Slide back to the first slide after a delay
            setTimeout(() => {
              flkty.select(0);
            }, 700); // Delay before sliding back
          }
          slideBackAndForth();
          hasAnimated = true; // Set the flag to true after the animation
        }

        // Stop observing to avoid repeated triggers
        observer.unobserve(entry.target);
      }
    });
  }

  // Function to observe the element and trigger the slider if width is <= 640px
  function observeSlider() {
    const element = document.querySelector('.ProductItem__ImageCarousel');

    if(!element) return;
    if (window.innerWidth <= 650) {
      const observer = new IntersectionObserver(triggerSliderOnce, {
        threshold: 1.0 // Trigger when the element is fully visible
      });

      observer.observe(element);
    }
  }

  // Initial check on load
  observeSlider();

  // Listen for window resize events
  window.addEventListener('resize', () => {
    // Re-check the screen width on resize and observe if <= 640px
    observeSlider();
  });
});

/* Add %OFF to upsell popup */
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const upsellPopup = document.querySelector('lb-upsell-addon-popup.hydrated');
      if (upsellPopup) {
        const priceWraps = upsellPopup.querySelectorAll('.lb-spc-details-price-wrap');

        priceWraps.forEach(wrap => {
          const originalPriceEl = wrap.querySelector('.lb-spc-details-cmp-price');
          const discountedPriceEl = wrap.querySelector('.lb-spc-details-price');

          // Skip if any of the elements are missing
          if (!originalPriceEl || !discountedPriceEl) return;

          const originalPriceText = originalPriceEl.textContent.trim();
          const discountedPriceText = discountedPriceEl.textContent.trim();

          if (originalPriceText && discountedPriceText) {
            const parsePrice = str => parseFloat(str.replace(/[^0-9.]/g, ''));

            const originalPrice = parsePrice(originalPriceText);
            const discountedPrice = parsePrice(discountedPriceText);

            if (originalPrice > discountedPrice) {
              const discountPercent = Math.floor(((originalPrice - discountedPrice) / originalPrice) * 100);

              // Prevent duplicate labels
              if (!wrap.querySelector('.custom-discount-label')) {
                const label = document.createElement('span');
                label.className = 'custom-discount-label';
                label.textContent = `${discountPercent}% OFF`;
                label.style.cssText = `
                  display: inline-block;
                  background-color: #f5f5f5;
                  color: black;
                  padding: 0.2em 0.5em;
                  font-size: 0.875rem;
                  margin-left: 0.5em;
                `;

                originalPriceEl.insertAdjacentElement('afterend', label);
              }
            }
          }
        });
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

const params = new URLSearchParams(window.location.search);
if (params.get('cart') === 'open') {
  const interval = setInterval(() => {
    if (typeof window.SLIDECART_OPEN === 'function') {
      window.SLIDECART_OPEN();
      clearInterval(interval);
    }
  }, 250);

  // Stop after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);
}

/*
document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('customAddToCartModal');
  var closeButton = document.getElementById('modal-close');

  if (modal && closeButton) {
    closeButton.addEventListener('click', function() {
      console.log('Modal closed with X button ❌');
      modal.close();
    });
  }
});
*/

function lazyLoadVideos() {
  const videos = document.querySelectorAll('video.lazy-video');
  if (!videos.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const wrapper = video.closest('.VideoWrapper');
        const poster = wrapper?.querySelector('.custom-poster');

        if (!video.querySelector('source')) {
          const source = document.createElement('source');
          source.src = video.dataset.src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();

          setTimeout(() => {
            video.play().catch(() => {});
          }, 100);
        }

        video.addEventListener('playing', () => {
          if (poster) poster.style.display = 'none';
        });

        obs.unobserve(video);
      }
    });
  }, {
    root: null,                // Use the viewport
    rootMargin: '0px',
    threshold: 0.6             // Trigger when at least 60% of the video is visible
  });

  videos.forEach(video => observer.observe(video));
}

document.addEventListener('DOMContentLoaded', () => {
  console.log(`[${performance.now().toFixed(2)}ms] DOMContentLoaded`);
  lazyLoadVideos();
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".CollectionTopLink").forEach(link => {
    link.addEventListener("click", () => {
      if (typeof gtag === "function") {
        gtag("event", "collection_button_click", {
          button_text: link.dataset.buttonText,
          destination: link.href,
          page_location: window.location.href
        });
        //console.log("✅ Sent GA4 event:", link.dataset.buttonText);
      } else {
        //console.warn("⚠️ gtag not found, GA4 event not sent");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const sortButtons = document.querySelectorAll(".Linklist--sort .Popover__Value");

  sortButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const sortBy = button.dataset.value;

      // update URL params like the theme normally does
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("sort_by", sortBy);
      currentUrl.searchParams.delete("page");

      // reload with sorted products
      if (window.theme && typeof window.theme.collection === "object" && typeof window.theme.collection._sortByChanged === "function") {
        // If you still have access to the Prestige collection object
        window.theme.collection._sortByChanged(sortBy);
      } else {
        // Fallback: reload directly
        window.location.href = currentUrl.toString();
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".CollectionTopFadeWrapper");
  if(!wrapper) return;
  
  const track = wrapper.querySelector(".CollectionTopFadeTrack");

  function updateFade() {
    const scrollLeft = track.scrollLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;

    // toggle left fade
    if (scrollLeft > 0) {
      wrapper.classList.add("has-left-fade");
    } else {
      wrapper.classList.remove("has-left-fade");
    }

    // toggle right fade
    if (scrollLeft < maxScroll - 1) {
      wrapper.classList.add("has-right-fade");
    } else {
      wrapper.classList.remove("has-right-fade");
    }
  }

  // run on load + when scrolling
  updateFade();
  track.addEventListener("scroll", updateFade);
  window.addEventListener("resize", updateFade);
});



document.addEventListener('DOMContentLoaded', function () {
  const breakpoint = 750;
  const carousel = document.querySelector('.ProductGallery--Newest .Product__Slideshow');
  if (!carousel) return;

  // Store original indexes ONCE
  carousel.querySelectorAll('.Product__SlideItem').forEach((slide, index) => {
    if (!slide.dataset.originalIndex) {
      slide.dataset.originalIndex = index;
    }
  });

  const videoCell = carousel.querySelector('.Product__SlideItem--video.Mobile--Hide');
  if (!videoCell) return;

  const originalIndex = Number(videoCell.dataset.originalIndex);
  let isRemoved = false;

  function updateCarousel() {
    const isMobile = window.innerWidth <= breakpoint;
    const flkty = Flickity.data(carousel);
    if (!flkty) return;

    if (isMobile && !isRemoved) {
      flkty.remove(videoCell);
      flkty.reloadCells();
      flkty.resize();
      isRemoved = true;
    }

    if (!isMobile && isRemoved) {
      flkty.insert(videoCell, originalIndex);
      flkty.reloadCells();
      flkty.resize();
      isRemoved = false;
    }
  }

  updateCarousel();
  window.addEventListener('resize', updateCarousel);
});


/* Six Stories Custom Tracking Layer */
window.SSAnalytics = {
 
  trackEvent(params) {

    const { type, ...payload } = params;

    console.group('[SS ANALYTICS]');
    console.log(JSON.parse(JSON.stringify(payload))); // forces snapshot
    console.groupEnd();

    Shopify.analytics.publish('ss_custom_interaction', payload);
  },

  trackElementInteractionFromQueue(item) {
    const section = item.section || {};

    this.trackEvent({
      event_name: item.event_name,
      section_name: item.section_name || item.section?.trackingName,
      section_type: item.section_type || item.section?.sectionType,
      promotion_type: item.promotion_type,
      interaction_type: item.interaction_type,
      item_name: item.item_title,
      product_id: item.product_id,
      product_title: item.product_title,
      label: item.label,
      destination_url: item.destination_url,
      link_text: item.link_text,
    });
    
  },

  trackElementInteraction(el) {
    const section = el.closest('.trackable-section');

    this.trackEvent({
      event_name: el.dataset.analyticsEvent,
      section_name:
        el.dataset.analyticsSectionName ||
        section?.dataset?.analyticsSectionName ||
        section?.dataset?.trackingName,
      section_type:
        el.dataset.analyticsSectionType ||
        section?.dataset?.analyticsSectionType ||
        section?.dataset?.sectionType,
      promotion_type: el.dataset.analyticsPromotionType,
      creative_name: el.dataset.analyticsCreativeName,
      creative_slot: el.dataset.analyticsCreativeSlot,
      item_name: el.dataset.analyticsItemTitle,
      item_position: el.dataset.analyticsItemPosition,
      label: el.dataset.analyticsLabel,
      destination_url: el.getAttribute('href'),
      link_text: el.dataset.analyticsLinkText || el.textContent.trim() || null,
      interaction_type: el.dataset.analyticsInteractionType,
    });
  },

  processQueue() {
    const queue = window.SSAnalyticsQueue || [];

    queue.forEach((item) => {
      if (item.type === 'element_interaction') {
        this.trackElementInteractionFromQueue(item);
      } else {
        this.trackEvent(item);
      }
    });

    window.SSAnalyticsQueue = [];
  }
};

// flush queued events when loaded
window.SSAnalytics.processQueue();


let ssIsDragging = false;
let ssDragStartX = 0;
let ssDragStartY = 0;

document.addEventListener('pointerdown', (e) => {
  ssIsDragging = false;
  ssDragStartX = e.clientX;
  ssDragStartY = e.clientY;
});

document.addEventListener('pointermove', (e) => {
  const deltaX = Math.abs(e.clientX - ssDragStartX);
  const deltaY = Math.abs(e.clientY - ssDragStartY);

  if (deltaX > 10 || deltaY > 10) {
    ssIsDragging = true;
  }
});

document.addEventListener('click', (e) => {
  if (ssIsDragging) return;
  const el = e.target.closest('[data-analytics-event]');
  if (!el) return;
  if (!window.SSAnalytics?.trackElementInteraction) return;
  window.SSAnalytics.trackElementInteraction(el);
});

document.addEventListener('click', (e) => {
  const sizeGuide = e.target.closest('.smartsize-trigger');
  if (!sizeGuide) return;

  window.SSAnalytics?.trackEvent({
    page_type: 'product-page',
    event_name: 'ui_interaction',
    interaction_type: 'size_guide_click',
    item_name: 'Size Guide',
    section_name: window.SS_PRODUCT_TITLE || null,
    item_position: null
  });
});

document.addEventListener('click', (e) => {
  const el = e.target.closest('.ProductForm .loox-rating.loox-widget');
  if (!el) return;

  window.SSAnalytics?.trackEvent({
    page_type: 'product-page',
    event_name: 'ui_interaction',
    interaction_type: 'rating_click',
    item_name: 'Rating',
    section_name: window.SS_PRODUCT_TITLE || null,
    item_position: null
  });
});


(function () {
  //console.log('[RBR] Script started');

  const PRODUCT_FORM_SELECTOR = '.ProductForm';
  const CONTAINER_SELECTORS = [
    '#rbr-container-element-true',
    '#rbr-container-element-false'
  ];

  const OPTIONS_GROUP_SELECTOR =
    '.Product__Info [class^="colorSwatch_variant_"] [class^="colorSwatch_options_"]';

  const OPTION_SELECTOR = '[class^="colorSwatch_option_"]';

  function getContainers(root = document) {
    return CONTAINER_SELECTORS.flatMap(sel =>
      Array.from(root.querySelectorAll(sel))
    );
  }

  function equalizeSwatches(container) {
    //console.log('[RBR] equalizeSwatches() running');

    const groups = container.querySelectorAll(OPTIONS_GROUP_SELECTOR);

    //console.log('[RBR] Groups found:', groups.length);

    groups.forEach((group, index) => {
      const options = group.querySelectorAll(OPTION_SELECTOR);

      //console.log(`[RBR] Group ${index} options found:`, options.length);

      if (!options.length) return;

      // Reset sizing before measuring
      options.forEach((option) => {
        option.style.width = '';
        option.style.height = '';
      });

      let maxSize = 0;

      options.forEach((option) => {
        const rect = option.getBoundingClientRect();

       // console.log( '[RBR] Option:', option.textContent.trim(), 'Width:', rect.width);

        maxSize = Math.max(maxSize, rect.width);
      });

      maxSize = Math.ceil(maxSize);

      //console.log(`[RBR] Final max size for group ${index}:`, maxSize);

      options.forEach((option) => {
        option.style.width = `${maxSize}px`;
        option.style.height = `${maxSize}px`;
        option.style.display = 'inline-flex';
        option.style.alignItems = 'center';
        option.style.justifyContent = 'center';
        option.style.boxSizing = 'border-box';
      });
    });
  }

  function updateSelectedLabel(option) {
    /*
    console.groupCollapsed('[RBR] updateSelectedLabel');

    console.log('[RBR] option clicked:', option);
    console.log('[RBR] dataset.value:', option?.dataset?.value);
    console.log('[RBR] textContent:', option?.textContent?.trim());
    */
    const variant = option.closest('[class^="colorSwatch_variant_"]');

    if (!variant) {
      //console.warn('[RBR] ❌ No variant container found');
      //console.groupEnd();
      return;
    }

    //console.log('[RBR] variant found:', variant);

    const title = variant.querySelector('[class^="colorSwatch_title_"]');

    if (!title) {
      //console.warn('[RBR] ❌ No title element found inside variant');
      //console.groupEnd();
      return;
    }

    //console.log('[RBR] title element:', title);
    //console.log('[RBR] current title text:', title.textContent);

    const selectedText =
      option.dataset?.value || option.textContent.trim();

    let originalLabel = title.dataset.originalLabel;

    if (!originalLabel) {
      originalLabel = title.textContent.trim();
      title.dataset.originalLabel = originalLabel;

      //console.log('[RBR] 🆕 storing original label:', originalLabel);
    } else {
      //console.log('[RBR] ♻️ using stored original label:', originalLabel);
    }

    const newText = `${originalLabel}: ${selectedText}`;

    //console.log('[RBR] computed label:', newText);

    if (title.textContent === newText) {
      //console.log('[RBR] ⏭️ no change needed (already set)');
      //console.groupEnd();
      return;
    }

    //console.log('[RBR] ✏️ updating DOM...');
    title.textContent = newText;

    //console.groupEnd();
  }

  function setupContainer(container) {
    //console.log('[RBR] setupContainer() called');

    if (container.dataset.swatchEqualized === 'true') {
      //console.log('[RBR] Container already initialized:', container);
      return;
    }

    
    const runWhenSwatchesExist = () => {
      const swatches = container.querySelectorAll(OPTION_SELECTOR);

      //console.log('[RBR] Swatches found:', swatches.length);

      if (!swatches.length) {
        //console.log('[RBR] No swatches yet');
        return;
      }

      equalizeSwatches(container);

      swatches.forEach((option) => {
        option.addEventListener('click', () => {
          updateSelectedLabel(option);
        });
      });

      container.dataset.swatchEqualized = 'true';

    };

    // Initial attempt
    runWhenSwatchesExist();

    // Watch container for updates
    const swatchObserver = new MutationObserver((mutations) => {
      //console.log('[RBR] Container mutation detected', mutations);

      runWhenSwatchesExist();
    });

    swatchObserver.observe(container, {
      childList: true,
      subtree: true,
    });

    //console.log('[RBR] Container observer attached');

    // Resize
    window.addEventListener('resize', () => {
      //console.log('[RBR] Window resized');

      runWhenSwatchesExist();
    });
  }

  function init() {
    //console.log('[RBR] init() running');

    const containers = getContainers(document);

    //console.log('[RBR] Containers found:', containers.length);

    containers.forEach(setupContainer);

    const formObserver = new MutationObserver((mutations) => {
      //console.log('[RBR] DOM mutation detected', mutations);

      const containers = getContainers(document);

      containers.forEach(setupContainer);
    });

    formObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    //console.log('[RBR] Global observer attached');
  }

  if (document.readyState === 'loading') {
    //console.log('[RBR] Waiting for DOMContentLoaded');

    document.addEventListener('DOMContentLoaded', init);
  } else {
    //console.log('[RBR] DOM already loaded');

    init();
  }
})();


/* Sticker Upsells - Offering the right variant */
(() => {
  const DEBUG_MODE = false;
  if(DEBUG_MODE) console.log('[Destination Upsells] Script loaded');

  if (!window.location.pathname.startsWith('/products/')) {
    if(DEBUG_MODE) console.log('[Destination Upsells] Not a product page:', window.location.pathname);
    return;
  }

  const TARGET_ADDON_NAME = 'Destination Bride Sticker Packs';

  const TITLE_TO_VARIANT = {
    'Destination Western Wifey Graphic Tee - White': 57297183572350,
    'Destination Western Wifey Baby Tee - White': 57297183572350,
    'Last Rodeo Destination Sweatshirt - White': 57297183572350,
    'Last Rodeo Destination Shorts - White': 57297183572350,
    'Last Rodeo Destination Bundle': 57297183572350,

    'Las Vegas Destination Shorts - White': 57297183539582,
    'Las Vegas Destination Sweatshirt - White': 57297183539582,
    'Las Vegas Destination Sweatpants - White': 57297183539582,

    'Greece Destination Sweatshirt - White': 57297183637886,
    'Greece Destination Graphic Tee - White': 57297183637886,
    'Greece Destination Shorts - White': 57297183637886,

    'Italy Destination Shorts - White': 57297183605118,
    'Italy Destination Sweatshirt - White': 57297183605118,
    'Wifey Wants a Spritz Beaded Tee - White': 57297183605118
  };

  let productDataPromise = null;

  function getProductData() {
    if (!productDataPromise) {
      if(DEBUG_MODE) console.log('[Destination Upsells] Fetching product JSON...');
      productDataPromise = fetch('/products/destination-bride-sticker-packs.json')
        .then(r => r.json())
        .then(data => {
          if(DEBUG_MODE) console.log('[Destination Upsells] Product JSON loaded');
          return data;
        });
    }
    return productDataPromise;
  }

  function createSpinner() {
    const wrap = document.createElement('div');

    wrap.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;min-height:120px;">
        <div style="
          width:34px;
          height:34px;
          border:3px solid #ddd;
          border-top-color:#000;
          border-radius:50%;
          animation:du-spin 0.8s linear infinite;
        "></div>
      </div>
    `;

    if (!document.getElementById('du-spin-style')) {
      const style = document.createElement('style');
      style.id = 'du-spin-style';
      style.textContent = `
        @keyframes du-spin {
          to { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }

    return wrap;
  }

  async function processPopup(popup) {
    if (popup.dataset.duProcessed === 'true') {
      if(DEBUG_MODE) console.log('[Destination Upsells] Already processed');
      return;
    }

    popup.dataset.duProcessed = 'true';

    if(DEBUG_MODE) console.log('[Destination Upsells] Processing popup', popup);

    const addonNameEl = popup.querySelector('.lb-spc-details-name');

    if(DEBUG_MODE) console.log('[Destination Upsells] Addon name:', addonNameEl?.textContent);

    if (!addonNameEl || !addonNameEl.textContent.includes(TARGET_ADDON_NAME)) {
      if(DEBUG_MODE) console.log('[Destination Upsells] Not target addon');
      return;
    }

    const originalDisplay = popup.style.display;

    const spinner = createSpinner();
    popup.style.display = 'none';
    popup.parentNode.insertBefore(spinner, popup);

    try {
      const currentProductTitle = document.querySelector('.ProductMeta__Title')
        ?.textContent
        ?.trim();

      if(DEBUG_MODE) console.log('[Destination Upsells] Product title:', currentProductTitle);

      const targetVariantId = TITLE_TO_VARIANT[currentProductTitle];

      if(DEBUG_MODE) console.log('[Destination Upsells] Target variant ID:', targetVariantId);

      if (!targetVariantId) return;

      const productJson = await getProductData();

      const variants = productJson?.product?.variants || [];

      const targetVariant = variants.find(
        v => Number(v.id) === Number(targetVariantId)
      );

      if(DEBUG_MODE) console.log('[Destination Upsells] Target variant:', targetVariant);

      if (!targetVariant) return;

      const imageSrc =
        targetVariant.featured_image?.src ||
        targetVariant.featured_media?.preview_image?.src ||
        null;

      if(DEBUG_MODE) console.log('[Destination Upsells] Image src:', imageSrc);

      const img = popup.querySelector('.lb-spc-image-cont img');

      if (img && imageSrc) {
        img.src = imageSrc;
        img.srcset = '';
        if(DEBUG_MODE) console.log('[Destination Upsells] Image updated');
      }

      const selects = popup.querySelectorAll('.lb-shared-variants-select');

      selects.forEach(select => {
        const option = [...select.options].find(opt =>
          opt.value.includes(String(targetVariantId))
        );

        if (!option) return;

        select.value = option.value;

        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

    } catch (err) {
      console.error('[Destination Upsells] Error:', err);
    } finally {
      spinner.remove();
      popup.style.display = originalDisplay;
      if(DEBUG_MODE) console.log('[Destination Upsells] Done');
    }
  }

  function observe() {
    if(DEBUG_MODE) console.log('[Destination Upsells] Watching addon container...');

    const containerSelector = '.lb-addon-popup-container';
    let processed = false;

    function tryProcess() {
      if (processed) return true;

      const container = document.querySelector(containerSelector);
      if (!container) return false;

      const nameEl = container.querySelector('.lb-spc-details-name');

      if (!nameEl) {
        if(DEBUG_MODE) console.log('[Destination Upsells] Container still empty...');
        return false;
      }

      const popup = container.closest('lb-upsell-addon-popup');

      if (!popup) {
        if(DEBUG_MODE) console.log('[Destination Upsells] Popup not found yet...');
        return false;
      }

      if(DEBUG_MODE) console.log('[Destination Upsells] Content hydrated → processing');

      processed = true;
      processPopup(popup);
      return true;
    }

    // 1. Observer (detect injection)
    const observer = new MutationObserver(() => {
      tryProcess();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 2. Polling fallback (detect hydration)
    const interval = setInterval(() => {
      if (tryProcess()) {
        console.log('[Destination Upsells] Stopping observer + polling');
        observer.disconnect();
        clearInterval(interval);
      }
    }, 200);

    // 3. initial attempt
    tryProcess();
  }

  observe();
})();

/* Searchanise Instant Search: Show Featured Collections and useful links when search query is empty */
(() => {
  const DEBUG = true;
  let isOpen = false;
  let emptyRendered = false;
  let linksRendered = false;

  const log = (...args) => {
    if (DEBUG) console.log('[SNIZE-EMPTY-CTRL]', ...args);
  };

  const state = {
    input: null,
    originalBox: null,
    lastEmptyState: false
  };

  // -----------------------------
  // BASIC STATE CHECKS
  // -----------------------------
  function isEmptyQuery() {
    return state.input && state.input.value.trim() === '';
  }

  function isFocused() {
    return document.activeElement === state.input;
  }

  function isEmptyMode() {
    return isFocused() && isEmptyQuery();
  }

  // -----------------------------
  // VISIBILITY CONTROL (unchanged)
  // -----------------------------
  function updateVisibility() {
    if (!state.originalBox) return;

    if (isEmptyMode()) {
      log('SHOW native autocomplete');

      state.originalBox.style.display = '';
      state.originalBox.style.visibility = 'visible';
      state.originalBox.style.opacity = '1';
    } else {
      log('LET Searchanise handle visibility');
    }
  }

  // -----------------------------
  // INPUT ATTACH
  // -----------------------------
  function attachEvents() {
    function getSearchInput() {
      return (
        document.querySelector('#snize-mobile-search-input') ||
        document.querySelector('input[type="search"]') ||
        document.querySelector('input[name*="search"]')
      );
    }

    const input = getSearchInput();

    if (!input) {
      log('Search input not found');
      return;
    }

    state.input = input;

    log('Attached input:', input);

    const run = () => handleStateChange();

    input.addEventListener('focus', run);
    input.addEventListener('click', run);
    input.addEventListener('input', run);
  }

  // -----------------------------
  // LABEL PATCH
  // -----------------------------
  function applyFeaturedCollectionsLabel() {
    let label = document.querySelector('#snize-products-label');

    // Label already exists → just rename it
    if (label) {
      label.textContent = 'FEATURED COLLECTIONS';
      return true;
    }

    // Otherwise create one
    const container = document.querySelector('#snize-ac-items-container-4');
    if (!container) return false;

    label = document.createElement('li');
    label.id = 'snize-products-label';
    label.className = 'snize-label';
    label.setAttribute('aria-hidden', 'true');
    label.textContent = 'FEATURED COLLECTIONS';

    container.insertAdjacentElement('afterbegin', label);

    return true;
  }

  // -----------------------------
  // RENDER FEATURED COLLECTIONS
  // -----------------------------
  function renderFeaturedCollections() {
    console.log('[SNIZE] RENDER FEATURED COLLECTIONS');
    const container = document.querySelector('#snize-ac-items-container-4');
    if (!container) return false;

    const dataEl = document.querySelector('#snize-featured-collections');
    if (!dataEl) return false;

    let data;
    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.log('[SNIZE-COLLECTIONS] JSON error', e);
      return false;
    }

    const collections = data.collections || [];

    // remove old injected items
    container
      .querySelectorAll('.snize-featured-collection')
      .forEach(el => el.remove());

    // remove empty state text
    const emptyText = container.querySelector('.snize-no-products-found-text');
    if (emptyText) emptyText.remove();

    const html = collections.map(col => `
      <li class="snize-product snize-featured-collection">
        <a class="snize-item" href="${col.url}">
          <div class="snize-thumbnail">
            <img src="${col.image || ''}" alt="${col.title}">
          </div>
          <span class="snize-title">${col.title}</span>
        </a>
      </li>
    `).join('');

    container.insertAdjacentHTML('beforeend', html);
    container.classList.remove('snize-hidden');


    log('[COLLECTIONS] rendered:', collections.length);
    return true;
  }

  function renderUsefulLinks() {
    const container = document.querySelector('#snize-ac-items-container-2');
    if (!container) return false;

    // prevent duplicates
    //if (linksRendered) return true;

    // clear anything Searchanise may have put there
    container.innerHTML = '';

    const links = [
      { title: 'About Us', url: '/pages/about' },
      { title: 'Contact', url: '/pages/contact' },
      { title: 'Shipping Info', url: '/pages/shipping' },
      { title: 'Returns', url: '/pages/returns' }
    ];

    const label = `
      <li id="snize-categories-label" class="snize-label" aria-hidden="true">
        Useful Links
      </li>
    `;

    const items = links.map((l, i) => `
      <li
        tabindex="0"
        class="snize-suggestion ${i % 2 === 0 ? 'snize-ac-even' : 'snize-ac-odd'}"
        aria-label="${l.title}"
        role="button"
        style="cursor: pointer;"
        onclick="window.location.href='${l.url}'"
      >
        <b>${l.title}</b>
      </li>
    `).join('');

    container.insertAdjacentHTML('beforeend', label + items);
    container.classList.remove('snize-hidden');

    linksRendered = true;

    console.log('[SNIZE] Useful links rendered');

    return true;
  }

  // -----------------------------
  // PATCH SUGGESTIONS: because the minimum amount of suggestions to show the autocomplete is 5
  // -----------------------------
  function patchSuggestions() {
    if (!window.Searchanise) return false;
    if (!Array.isArray(Searchanise.preloadedSuggestions)) return false;

    const dataEl = document.querySelector('#snize-search-suggestions');
    if (!dataEl) return false;

    let data;

    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.error('[SNIZE] Invalid suggestions JSON', e);
      return false;
    }

    const fallbackSuggestions = data.suggestions || [];
    const suggestions = Searchanise.preloadedSuggestions;

    // Only pad up to 5 suggestions
    let i = 0;

    while (
      suggestions.length < 5 &&
      i < fallbackSuggestions.length
    ) {
      suggestions.push(fallbackSuggestions[i]);
      i++;
    }

    return true;
  }

  // -----------------------------
  // CORE STATE ENGINE (IMPORTANT FIX)
  // -----------------------------
  function handleStateChange() {
    console.log('[SNIZE] HANDLE STATE CHANGE');
    const input = state.input;
    if (!input) return;

    const empty = input.value.trim() === '';
    const focused = document.activeElement === input;

    const emptyMode = empty && focused;
    
    console.log('[SNIZE STATE]', { empty, focused, isOpen });

    if (emptyMode && !emptyRendered) {
      emptyRendered = true;

      console.log('[SNIZE] EMPTY MODE ENTER');

      applyFeaturedCollectionsLabel();
      renderFeaturedCollections();
      renderUsefulLinks();
    }

    if (!emptyMode) {
      emptyRendered = false;
    }
  }

  function cleanupFeaturedUI() {
    const container = document.querySelector('#snize-ac-items-container-4');
    if (!container) return;

    // remove injected collections
    container.querySelectorAll('.snize-featured-collection')
      .forEach(el => el.remove());

    const label = document.querySelector('#snize-products-label');
    if (label) label.textContent = 'Products';

    linksRendered = false;

    console.log('[SNIZE] cleaned up on close');
  }

  // -----------------------------
  // SEARCHANISE BOX DETECTION
  // -----------------------------
  function watchForSearchaniseBox() {
    const observer = new MutationObserver(() => {
      const box =
        document.querySelector('.snize-ac-results') ||
        document.querySelector('.searchanise-ac-results');

      if (!box) return;

      state.originalBox = box;

      log('Searchanise box detected');

      patchSuggestions();
      attachEvents();

      handleStateChange(); // initial sync
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    log('Observer started');
  }

  function watchEmptyProductsState() {
    const observer = new MutationObserver(() => {

      if (!isEmptyMode()) return;

      const container = document.querySelector(
        '#snize-ac-items-container-4'
      );

      if (!container) return;

      const emptyState = container.querySelector(
        '.snize-no-products-found-text'
      );

      if (!emptyState) return;

      log('Empty products detected -> patching');

      applyFeaturedCollectionsLabel();
      renderFeaturedCollections();
      renderUsefulLinks();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    log('Empty state observer started');
  }

  function watchAutocompleteState() {
    const observer = new MutationObserver(() => {
      const root = document.querySelector('#snize-instant-search-results');
      if (!root) return;

      const hidden = root.classList.contains('snize-hidden');

      const columns = root.querySelector('.snize-ac-results-columns');
      const html = root.querySelector('.snize-results-html');

      const columnsHidden = columns?.classList.contains('snize-hidden');
      const htmlHidden = html?.classList.contains('snize-hidden');

      const nowOpen = !hidden;

      // detect transition OPEN
      if (nowOpen && !isOpen) {
        isOpen = true;
        console.log('[SNIZE] OPEN');

        handleStateChange();
      }

      // detect transition CLOSE
      if (!nowOpen && isOpen) {
        isOpen = false;
        console.log('[SNIZE] CLOSED');

        cleanupFeaturedUI();
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    console.log('[SNIZE] state watcher started');
  }

  // -----------------------------
  // INIT
  // -----------------------------
  function init() {
    patchSuggestions();
    watchForSearchaniseBox();
    watchEmptyProductsState();
  }

  document.addEventListener('DOMContentLoaded', init);
})();

/* Improve Searchanise's search results upon page load */
$(document).on('Searchanise.ResultsUpdated', function (event, container) {
  if (window.innerWidth < 768) return;

  container.find('img[src*="_large"]').each(function () {
    const img = this;

    if (img.dataset.upgraded) return;

    img.dataset.upgraded = '1';

    const newSrc = img.src.replace('_large.', '_800x800.');

    const preload = new Image();
    preload.onload = function () {
      img.src = newSrc;
    };
    preload.src = newSrc;
  });
});

/* Open the modal popup after ATC but before Slidecart */
/*
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom ATC button click interception loaded ✅');

  var modal = document.getElementById('customAddToCartModal');

  document.querySelectorAll('form[action="/cart/add"] button[type="submit"]').forEach(function(button) {
    button.addEventListener('click', function(event) {
      console.log('✅ ATC button clicked:', button);

      event.preventDefault();  // Stop default click → stops SlideCart from running its form handler yet

      var form = button.closest('form');
      var formData = new FormData(form);
      var selectedVariantId = parseInt(formData.get('id'));

      console.log('Selected Variant ID:', selectedVariantId);

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart fetched ✅', cart);

          // Optional: Get the product_id for the selected variant
          fetch('/variants/' + selectedVariantId + '.js')
            .then(response => response.json())
            .then(function(variantData) {
              var selectedProductId = variantData.product_id;

              var duplicateVariantExists = cart.items.some(function(item) {
                return item.product_id === selectedProductId && item.variant_id !== selectedVariantId;
              });

              if (duplicateVariantExists) {
                console.log('Duplicate variant found ✅ Showing modal');

                if (modal) {
                  modal.showModal();

                  document.getElementById('modal-add-to-cart').onclick = function() {
                    console.log('User confirmed Add Anyway ✅');
                    modal.close();
                    form.submit();  // Now submit the form, triggering SlideCart's flow
                  };

                  document.getElementById('modal-find-size').onclick = function() {
                    console.log('User chose Find Size ✅');
                    modal.close();
                    window.location.href = '/pages/size-finder';
                  };
                } else {
                  console.warn('Modal not found ❌ Submitting form anyway');
                  form.submit();
                }
              } else {
                console.log('No duplicate variant ✅ Submitting form immediately');
                form.submit();
              }
            });
        });
    });
  });
});
*/
